import type { ComponentProps } from 'react';
import { UMLayersPanel, UMLegendItem, UM_LAYER_CATALOG } from '../_components';
import { NetworkLegend } from './NetworkLegend';
import type { useNetwork } from './useNetwork';

const energy = UM_LAYER_CATALOG.find(group => group.id === 'energy-networks')!;
const groups = UM_LAYER_CATALOG.map(group => group === energy ? { ...group, legend: [] } : group);

/** Local slot composition: insert the selection line just after the existing blue line. */
export function SelectionLayersPanel({ network, selectionLabel, onEditLegend, ...props }: ComponentProps<typeof UMLayersPanel> & {
  network: ReturnType<typeof useNetwork>; selectionLabel: string; onEditLegend: () => void;
}) {
  // Sans sélection courante : légende catalogue d'origine, aucune canalisation de sélection.
  if (!selectionLabel) return <UMLayersPanel {...props} />;
  return <UMLayersPanel {...props} groups={groups} renderGroupExtra={id => id === 'energy-networks' ?
    <div aria-label={`Légende réseau ${selectionLabel}`} style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <NetworkLegend context="layers" density={network.density} visible={network.pipesVisible} onEditLegend={onEditLegend}
        onVisibilityChange={network.setPipesVisible} existingLegend={<UMLegendItem {...energy.legend![1]} />} />
      {energy.legend!.slice(2).map(item => <UMLegendItem key={item.label} {...item} />)}
    </div> : undefined} />;
}
